"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debugReelResult = debugReelResult;
/**
 * Print a reel result to console.
 * used for debugging
 * @returns 
 */
function debugReelResult(matrix) {
  var t = matrix[0].map(function (col, i) {
    return matrix.map(function (row) {
      return row[i];
    });
  });
  if (matrix[0].length > 3) t.push(0); // hack due to chromeium bug with 4 rows...
  console.table(t);
}
//# sourceMappingURL=debugReelResult.js.map